import { SettingMainItemsKeys } from './SettingMainItemsKeys';
import { SettingsSubKeys } from './SettingsSubKeys';

export { SettingEventsEnum } from './SettingEventsEnum';
// export { SettingMainItemsKeys } from './SettingMainItemsKeys';

export enum DemoUrlDisplay {
  full = 'full',
  only_domain = 'only_domain',
  hide = 'hide',
}

export type SettingsStateType = {
  [key in SettingMainItemsKeys]: {
    [subKey in SettingsSubKeys]?: any;
  };
};

export { SettingMainItemsKeys, SettingsSubKeys };
